module.exports = __webpack_public_path__ + "fb4e7e50b0bbbd65ecd4a19d774b5950.png";